<div class="content">
  <div class="content-top">
    <div class="content-input">
      <ng-container *ngIf="showSeparators; else plainInput">
        <div class="btn clear" [class.input_not_valid]="!inputValid">
          <ng-container *ngFor="let number of inputNumbers; let isLast = last;">
            <div class="input-number" [ngClass]="!isLast?'seperate':''">
              <span class="number" *ngIf="number">{{number}}</span>
              <ng-container *ngIf="displayDots">
                <span *ngIf="number==''">&#9679;</span>
              </ng-container>
            </div>
          </ng-container>
        </div>
      </ng-container>
      <ng-template #plainInput>
        <div class="btn clear no-separators" [class.input_not_valid]="!inputValid">
          <span class="plain-result" [class.plain-result--empty]="!numberPadResult">{{numberPadResult}}</span>
        </div>
      </ng-template>
    </div>
  </div>
  <div class="content-number-pad">
    <ng-container *ngFor="let number of numbers; let i = index; ">
      <ng-container *ngIf=" i===numbers.length - 1">
        <div [class.loadAnimation]="removeBtnState==='start'" [class.reloadAnimation]="removeBtnState==='end'"
          (click)="removeLast() " inlineSVG="sot/backx.svg">
        </div>
      </ng-container>
      <div [class.loadAnimation]=" animationStates[number]==='start'"
        [class.reloadAnimation]="animationStates[number]==='end'"
        [class.disabled]="atMaxLength"
        (click)="addNumber(number)">
        {{number}}</div>
    </ng-container>
  </div>
</div>
